import { useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ORDER_MENIFETCH, REFUND_ORDER_MUTATION } from '../graphql/Mutation/Ordre.js';
import SpinLoader from '../components/SpinLoader.js';
import { toast } from 'react-toastify';
import { useRef } from 'react';
import { API_URL } from '../config.js';

const CodSuccessPayment = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/allOrders'); // Redirect after 5 seconds
        }, 5000);

        return () => clearTimeout(timer); // Cleanup the timer when the component unmounts
    }, [navigate]);
   
    return (
        <div className={` bg-green-700 h-screen w-screen flex justify-center items-center`}>
            <div className='text-center'>

                <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/successgif.png" className='animate-bounce drop-shadow-2xl mx-auto' alt="" />

                <p className='font-semibold text-white text-3xl mb-6'>Shipment Success!</p>
                <div> <Link to="/allOrders"> <button
                    className="py-2.5 px-3 w-full inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-white text-black hover:bg-white focus:outline-none text-sm"
                >
                    Go to All Shipment            </button></Link></div>


            </div>
        </div>
    );
}

export default CodSuccessPayment;
